import { apiClient } from '@/shared/api';
import { ImpersonationResponse, LoginRequest } from './types';

export const logout = () => apiClient.post('/auth/logout');

/**
 * Вход по email и паролю. Ответ без тела: признак временного пароля берётся из профиля.
 * Об отказе форма входа сообщает под собой, поэтому общее уведомление не поднимается
 */
export const login = (credentials: LoginRequest) => apiClient.post('/auth/login', credentials, { silentError: true });

/** Продление сессии по решению пользователя: срок отсчитывается заново от момента обращения */
export const extendSession = () => apiClient.post('/auth/extend');

/** Начало работы от имени пользователя с идентификатором userId */
export const startImpersonation = async (userId: number) => {
  const { data } = await apiClient.post<ImpersonationResponse>(`/auth/impersonate/${userId}`);
  return data;
};

/** Возврат в собственную учётную запись из режима работы от чужого имени */
export const stopImpersonation = async () => {
  const { data } = await apiClient.post<ImpersonationResponse>('/auth/impersonate/stop');
  return data;
};
